import { graphql } from '@/generated/gql';

export const SAVING_HISTORY_QUERY = graphql(/* GraphQL */ `
  query SavingHistoryQuery($entityId: UUID!, $limit: Int) {
    telescope {
      logEntries(entityId: $entityId, entityVariant: SAVING, limit: $limit, includeChildren: false) {
        nodes {
          actorId
          actorVariant
          context
          createdAt
          entityId
          entityVariant
          id
          parentId
          parentVariant
          status
          template
        }
        totalCount
      }
    }
  }
`);
